(ns frontend.view.reports.custom.alj-2.active-deals-per-deal-type-bar-chart
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]
   [reagent.core :as r]))

(defn bar-deals-per-deal-type
  [deals]
  (let [deal-type-frequencies (->> deals
                                   (mapcat :oppo/tag-deal-type)
                                   (frequencies)
                                   (sort-by second)
                                   (reverse))
        other-count (->> deal-type-frequencies
                         (drop 5)
                         (keep second)
                         (apply +))
        other-names (->> deal-type-frequencies
                         (drop 5)
                         (keep first)
                         (map (fn [tag-id]
                                (entity/display-string (get @session/entities tag-id))))
                         (doall))]
    [{:series [{:name (loc/tr :oppo/tag-deal-type)
                :data (concat (->> deal-type-frequencies
                                   (take 5)
                                   (map (fn [[tag-id deal-count]]
                                          (let [tag (get @session/entities tag-id)]
                                            {:name (entity/display-string tag)
                                             :y    deal-count})))
                                   (vec))
                              (when (and (number? other-count)
                                         (pos? other-count))
                                [{:name (loc/tr :other)
                                  :y    other-count}]))}]}
     (seq other-names)]))

(defn report
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [active-deals (->> (alj/all-deals)
                              (cu/filter-by :oppo/status :oppo.status/ok)
                              (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))
            [chart-data other-names] (bar-deals-per-deal-type active-deals)
            export-data (->> chart-data
                             :series
                             (first)
                             :data
                             (map (fn [{:keys [name y]}]
                                    [name y]))
                             (doall))
            view-name (loc/tr :total-active-deals-by-tag-deal-type)]
        [alj-components/alj-bar-chart
         {:view-name       view-name
          :total-deals     (count active-deals)
          :total-amount    (alj-utils/ticket-size-sum-billions active-deals)
          :report-data     export-data
          :chart-data      chart-data
          :date-state-atom date-state-atom
          :footer-content  (when other-names
                             [:ol.pl-4.pb-4.mr-4.ml-4
                              [:li.text-size--sm "Others include: "
                               (string/join ", " other-names)]])}]))))
